import {AxiosInstance} from "axios";
import {TwilioTokenDataApiDto} from "./model/rest";

export default class TwilioApi {
	constructor(public readonly axiosInstance: AxiosInstance) { }

	/**
	 * Fetch token to connect to the Twilio voice.
	 * @returns {Promise<TwilioTokenDataApiDto>}
	 */
	fetchToken(): Promise<TwilioTokenDataApiDto> {
		const url = "/api/web/voice/token";
		return this.axiosInstance.get(url).then(resp => resp.data.token);
	}
}
